import { CommonModule } from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import { FeatureFlagsService } from './core/feature-flags.service';
import { GETS_FEATURE_FLAGS } from './core/gets-feature-base.service';
import { GetFeatureFromStateService } from './core/infrastructure/get-feature-from-state.service';
import { FeatureFlagsDirective } from './directives/feature-flags.directive';
import { FeatureFlagsGuard } from './guards/featue-flags.guard';

@NgModule({
  declarations: [FeatureFlagsDirective],
  exports: [FeatureFlagsDirective],
  imports: [CommonModule],
})
export class FeatureFlagsModule {

  static forRoot(): ModuleWithProviders<FeatureFlagsModule> {
    return {
      ngModule: FeatureFlagsModule,
      providers: [
        {
          provide: GETS_FEATURE_FLAGS,
          useClass: GetFeatureFromStateService
        },
        FeatureFlagsGuard,
        FeatureFlagsService
      ]
    }
  }

}
